import { InteractionsLogger } from './interactionsLogger';
import { PlaceEventInteraction } from './placeEventInteraction';

export class InteractionsLoggerV2 implements InteractionsLogger {
    ORIGIN = 'web';
    log(interactions: Array<PlaceEventInteraction>) {
        const logs = {
            records: interactions.map((i) => ({
                app: this.ORIGIN,
                interface: i.place.name,
                sub_interface: i.place.subInterface.name,
                campaign_id: null,
                user_id: parseInt(i.user.id),
                rank: i.place.position,
                place_id: parseInt(i.place.context.place_id),
                guest_id: i.user.guestId,
                event_id: parseInt(i.item.id),
                ad_id: parseInt(i.adId),
                placement_id: i.place.placementId,
                session_id: i.user.sessionId,
                tab_key: i.place.tabKey,
                action: i.action,
                actions: ['EngagementAction'],
                position: i.place.subInterface.position,
                query_terms: i.place.context.query_terms,
                date_filter: this.getDateFilter(i.place.context.date_filter),
                is_online: +i.place.context.is_online,
                related_event_id: parseInt(i.place.context.related_event_id),
                locale: i.user.locale,
                page: i.place.page,
                search_id: i.place.context.search_id,
                tags: i.place.context.tags || [],
            })),
        };
        fetch(this.getLogEngagementUrl(), {
            method: 'PUT',
            body: JSON.stringify(logs),
            headers: { 'Content-Type': 'application/json' },
        });
    }

    private getDateFilter(date_filter: string[] | string) {
        if (!date_filter) {
            return null;
        }
        return Array.isArray(date_filter)
            ? date_filter.filter((v) => v)
            : [date_filter];
    }

    private getLogEngagementUrl() {
        const trackingSubdomains = [
            { domain: 'evbdev', target: 'evbdev' },
            { domain: 'dev.evbqa', target: 'evbqa' },
            {
                domain: 'eventbrite',
                target: 'eventbrite',
            },
            { domain: 'evbqa', target: 'evbqa' },
        ];
        const subdomain = 'v2qj0kr5adsxp';

        const { target } = trackingSubdomains.find((s) =>
            location.hostname.includes(s.domain),
        ) || { domain: '', subdomain: '' };

        return `https://${subdomain}.${target}.com/log_engagement/records`;
    }
}
